import { useState } from "react";
import { IdCardUpload } from "../contact/IdCardUpload";
import { IdCardList } from "../contact/IdCardList";

interface IdCardSectionProps {
  contactId: string;
}

export const IdCardSection = ({ contactId }: IdCardSectionProps) => {
  const [refreshIdCards, setRefreshIdCards] = useState(0);

  const handleUploadComplete = () => {
    setRefreshIdCards(prev => prev + 1);
  };

  return (
    <div className="space-y-4">
      <IdCardUpload contactId={contactId} onUploadComplete={handleUploadComplete} />
      <IdCardList contactId={contactId} key={refreshIdCards} />
    </div>
  );
};